export default __webpack_public_path__ + "static/stuck-1b27ab181de3dd45e2f5066fc7ee0ef7.png";